import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// Measurements are from `3574:32905`: each category is a card with a 72px header (24px padding, a
// 24px chevron 16px before an 18px bold title, the count on the right), opening onto a table with a
// shaded Page / Description / Status / Action header row and 64px rows.
export const styles = (theme: Theme) => {
	return ({
		description: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginBottom: theme.spacing(2),
		},
		headScript: {
			marginBottom: theme.spacing(3),
		},
		// The card itself is shared/category-accordion. Doubled `&&` so these outrank its own margin and
		// MUI's expanded-state rules: 16px between cards here rather than campaigns' 12, and a 72px
		// header that doesn't grow when opened.
		accordion: {
			"&&, &&.Mui-expanded": {
				margin: theme.spacing(0, 0, 2),
			},
			"&&:last-child": {
				marginBottom: 0,
			},
		},
		summary: {
			"&&, &&.Mui-expanded": {
				minHeight: 72,
				padding: theme.spacing(0, 3),
			},
			"&& .MuiAccordionSummary-content": {
				margin: 0,
			},
		},
		header: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: theme.spacing(2),
			width: "100%",
		},
		title: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(2),
			fontSize: 18,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		chevron: {
			flexShrink: 0,
			color: theme.palette.primary.main,
		},
		count: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(0.5),
			fontSize: 16,
			lineHeight: "20px",
			whiteSpace: "nowrap",
			color: theme.palette.custom.textPrimary,
		},
		warningIcon: {
			flexShrink: 0,
			color: theme.palette.custom.warning,
		},
		details: {
			padding: 0,
			borderTop: `1px solid ${theme.palette.custom.borderCard}`,
		},
		pageName: {
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(1),
			whiteSpace: "nowrap",
		},
		action: {
			minWidth: 0,
			whiteSpace: "nowrap",
		},
	} satisfies Record<string, CSSObject>);
};
